import { useLearnerInfo } from "@/api/services/main/learner";
import { LoadingPage } from "@/components/elements/Loading/Loading";
import { LearnerForm } from "@/features/learner/components/LearnerForm";
import { convertResToFormData } from "@/features/learner/utils/convertLearnerFormData";
import { useValidateId } from "@/hooks/useValidateId";
import { AppRoutes } from "@/routes/config";

const LearnerEdit = () => {
  const queryResult = useLearnerInfo();
  const { data, isLoading } = queryResult;
  useValidateId("learnerId", AppRoutes.learnerList, queryResult);

  if (!data || isLoading) return <LoadingPage />;
  return <LearnerForm defaultValues={convertResToFormData(data.data)} procedureStatusKey={data.data?.procedureStatusKey ?? null} />;
};

export default LearnerEdit;
